import { render } from "./RoundButton.vue?vue&type=template&id=6786add6&scoped=true&ts=true"
import script from "./RoundButton.vue?vue&type=script&lang=ts"
export * from "./RoundButton.vue?vue&type=script&lang=ts"

import "./RoundButton.vue?vue&type=style&index=0&id=6786add6&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6786add6"]])

export default __exports__